<template>
  <div class="container">
    <!--    <el-scrollbar style="margin: 10px 0px 1px 0px;">-->
    <!--      <div style="display: flex;flex-flow: row;justify-content: center;width: 100%;height: 100%">-->
    <div class="main-container-bg">
      <div class="main-container">
        <div class="bg" ref="bg" style="pointer-events: none;">
          <div class="top-button" @click="clickToEdit" style="cursor: pointer;pointer-events: auto;">
                      编辑
          </div>
          <div class="info-wrap-top">
            <div class="info-content">
              <label>
                <div class="user-avatar">
                  <img style="width: 90px;height: 90px;border-radius: 50%;cursor: pointer;" :src="form.avatar || defaultAvatar" alt=""/>
                </div>
                <input type="file" accept="image/*" style="display:none" @change="imgUpload"/>
              </label>
            </div>
          </div>
          <div class="info-wrap-top">
            <div class="info-content">
<!--              <div class="info-name">{{ form.name }}</div>-->
              <input class="info-name" v-model="form.username" type="text" style="cursor:pointer;"/>
            </div>
          </div>
          <div class="info-wrap"> 
            <div class="info-header">
              <img style="width: 20px;height: 20px;" src="@/assets/zhibo/sex.png">性别：
            </div>
            <div class="info-content">
              <el-select class="input-invisible" v-model="form.sex">
                <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                >
                </el-option>
              </el-select>
              <input style="width:220px;" readonly :value="sexText" type="text" placeholder="请选择" :disabled = "showEdit"/>
              <!--          <i class="el-icon-arrow-right"></i>-->
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-header">
              <img src="@/assets/zhibo/mobile.png">手机：
            </div>
            <div @click="showAddPhone = showEdit " class="info-content">
              <input v-model="form.mobile" type="text"/>
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-header">
              <img style="width: 18px;height: 15px" src="@/assets/zhibo/email.png">邮箱：
            </div>
            <div class="info-content">
              <input v-model="form.email" type="text" />
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-header">
              <img src="@/assets/zhibo/company.png">企业名称：
            </div>
            <div class="info-content">
              <input style="width: 195px;" v-model="form.company" type="text" />
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-header">
              <img style="width: 18px;height: 18px;" src="@/assets/zhibo/depart.png">部门：
            </div>
            <div class="info-content">
              <input v-model="form.department" type="text" />
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-header">
              <img style="width: 16px;height: 18px;" src="@/assets/zhibo/zhiwei.png">职位：
            </div>
            <div class="info-content">
              <input v-model="form.position" type="text" />
            </div>
          </div>
          <div class="info-wrap">
            <div class="info-header">
              <img src="@/assets/zhibo/hangye.png">所属行业：
            </div>
            <div class="info-content">
              <el-select class="input-invisible" v-model="form.industry">
                <el-option
                    v-for="(item, index) in industryList"
                    :key="index"
                    :label="item"
                    :value="item"
                >
                </el-option>
              </el-select>
              <input style="width: 195px;" :value="form.industry" readonly type="text"/>
            </div>
          </div>
          <div class="info-wrap-top">
            <div v-if="showEdit" @click="submit()" class="main-btn" style="cursor: pointer;">
              保存
            </div>
            <div v-else style="height: 40px"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-list">
      <div class="my-tab">
        <div class="tab" style="cursor: pointer;"
             @click="tab = 0"
             :class="{ active: tab == 0 }">
          我的直播<img v-if="tab == 0" src="@/assets/zhibo/zhibo.png"><img v-if="tab !== 0"
                                                                           src="@/assets/zhibo/unzhibo.png">
        </div>
        <img class="show" v-if="tab == 0" src="@/assets/zhibo/smaller.png">
        <div class="tab" style="cursor: pointer;"
             @click="tab = 1"
             :class="{ active: tab == 1 }">
          我的关注<img v-if="tab == 1" src="@/assets/zhibo/guanzhu.png"><img v-if="tab !== 1"
                                                                             src="@/assets/zhibo/unguanzhu.png">
        </div>
        <img class="show1" v-if="tab == 1" src="@/assets/zhibo/smaller.png">
        <div class="tab" style="cursor: pointer;"
             @click="tab = 2"
             :class="{ active: tab == 2 }">
          问题反馈<img v-if="tab == 2" style="width: 25px;height: 25px" src="@/assets/zhibo/wentifankui.png"><img
            v-if="tab !== 2" style="width: 25px;height: 25px" src="@/assets/zhibo/unwentifankui.png">
        </div>
        <img class="show2" v-if="tab == 2" src="@/assets/zhibo/smaller.png">
      </div>
    </div>
    <div v-if="tab == 0" class="live">
      <div class="category">
        <div
            class="category-wrap"
            @click="tabs = 1"
            :class="{ actives: tabs == 1 }"
        >
          <div class="category-card">我的预约<img v-if="tabs == 1" src="@/assets/zhibo/yuyue.png"><img v-if="tabs !==1"
                                                                                                       src="@/assets/zhibo/unyuyue.png">
          </div>
        </div>
        <div
            class="category-wrap"
            @click="tabs = 3"
            :class="{ actives: tabs == 3 }"
        >
          <div class="category-card">我的收藏<img v-if="tabs == 3" src="@/assets/zhibo/shoucang.png"><img
              v-if="tabs !== 3" src="@/assets/zhibo/unshoucang.png"></div>
        </div>
        <div
            class="category-wrap"
            @click="tabs = 2"
            :class="{ actives: tabs == 2 }"
        >
          <div class="category-card">观看历史<img v-if="tabs == 2" src="@/assets/zhibo/lishijilu.png"><img
              v-if="tabs !== 2" src="@/assets/zhibo/unlishijilu.png"></div>
        </div>
      </div>
      <div class="category-list">
        <el-scrollbar style="margin: 0px 10px;height: 100%;width: 775px;">
          <div class="streaming-wrap" @click="$router.push('/streaming-page/' + item.live.id)"
               v-for="item in list"
               :key="item.live.id">
            <div class="streaming-img">
              <img :src="item.live.img_pc" alt="" @click="$router.push('/streaming-page/' + item.live.id)"/>
            </div>
            <div class="streaming-time"><img src="@/assets/time.png" alt=""/>直播时间：{{ item.live.start_at }}</div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div v-if="tab == 1" class="favorite">
      <el-scrollbar style="height: 100%;width: 830px;margin: 20px;">
        <div class="top-list-li"
             v-for="item in follows"
             :key="item.id">
          <div class="top-list">
            <div class="avatar" @click="goDetails(item.id,item.name,item.detail,item.avatar)">
              <img :src="item.avatar" alt="" class="user-avatar"/>
            </div>
            <div class="c-username">{{ item.username }}</div>
            <div class="c-detail" v-html="item.detail">{{ item.detail }}</div>
            <div class="follow">
              <img v-if="true" src="@/assets/zhibo/shixin.png" @click="onUnfollow(item.id)">
              <img v-else src="@/assets/zhibo/kongxin.png" @click="onFollow(item.id)">
            </div>
            <div class="c-follow">{{ item.follow_cnt }} 人关注</div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <div v-if="tab == 2" class="question">
      请填写您要反馈的问题
      <div class="area"><textarea v-model="feedbackContent"></textarea></div>
      <div class="bottom">
        <div @click="submitFb()" class="main-btn" style="cursor: pointer;">
          提交
        </div>
      </div>
    </div>
    <!--      </div>-->
    <!--    </el-scrollbar>-->
    <el-dialog title="修改手机" :visible.sync="showAddPhone" width="500px">
      <div class="input-area">
        <div class="input-cell">
          <div class="input-header">
            手机号
          </div>
          <input v-model="mobile" type="text" placeholder=""/>
        </div>
        <div class="input-cell">
          <div class="input-header">
            验证码
          </div>
          <input v-model="captcha" type="text" placeholder=""/>
          <div
              class="captcha-btn login-btn"
              :class="{ 'btn-disabled': captchaStatus }"
              v-loading="captchaLoading"
          >
            <span @click="getCaptcha" v-if="!captchaStatus">发送验证码</span
            >
            <van-count-down @finish="captchaStatus = false" v-else :time="time">
              <template v-slot="timeData">
                <span class="block">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="background:white;border:1px solid rgb(41, 116, 66);"
                   @click="showAddPhone = false">取 消</el-button>
        <el-button style="background:rgb(41, 116, 66);border:none;" type="primary" @click="submit2">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getUserInfo, profileEdit, getCaptcha, profileEdit2, feedback} from "@/api/user";
import industry from "@/utils/industry";
import {fileUpload} from "@/api/file";
import avatar from "@/assets/photo.png";
import {follow, getFavsList, getFollows, getHistoryList, getSubscribeList, unfollow} from "@/api/stream";
import moment from "moment";

export default {
  name: "",
  props: {
    streamName: {type: String, default: ""},
    onlineCount: {type: Number, default: 0},
    startAt: {type: String, default: ""},
    streamerInfo: {type: Object, default: undefined},
    isFollowed: {type: Boolean}
  },
  components: {},
  data() {
    return {
      feedbackContent:'',//反馈内容
      tab: 0,
      tabs: 1,
      showAddPhone: false,
      showEdit: false,
      industryList: industry,
      sexList: [
        {name: "男", value: 1},
        {name: "女", value: 2},
        {name: "其他", value: 3},
      ],
      defaultAvatar: avatar,
      form: {
        sex: 1,
        avatar: "",
        name: "",
        industry: "",
        mobile: "",
        position: "",
        company: "",
        email: "",
        department: "",
      },
      mobile: "",
      captcha: "",
      time: 60 * 1000,
      captchaStatus: false,
      captchaLoading: false,
      follows: [],
      list: [],
      finished: false,
      page: 1,
    };
  },
  computed: {
    sexText() {
      if (this.form.sex) {
        let text = "";
        this.sexList.forEach((item) => {
          if (item.value == this.form.sex) {
            text = item.name;
            return;
          }
        });
        return text;
      } else {
        return "";
      }
    },
  },

  watch: {
    tabs() {
      this.list = []
      this.finished = false;
      this.page = 1;
      this.getList(1);
    },
  },

  created() {
    getUserInfo().then((res) => {
      if (res.code == 200) {
        this.form.avatar = res.data.avatar;
        this.form.username = res.data.username;
        this.form.name = res.data.name;
        this.form.sex = res.data.sex;
        this.form.mobile = res.data.mobile;
        this.form.email = res.data.email;
        this.form.company = res.data.company;
        this.form.position = res.data.position;
        this.form.industry = res.data.industry;
        this.form.department = res.data.department;
      }
    });
    this.getList(1);
    this.getFollows();
  },
  methods: {
    clickToEdit(){//编辑个人信息
      this.$nextTick( () => {
        this.showEdit = !this.showEdit;
        let pointerEvents = this.$refs.bg.style.pointerEvents;
        console.log(pointerEvents)
        let edit = pointerEvents == 'none' ? 'auto' : 'none';
        console.log(edit)
        this.$refs.bg.style.pointerEvents = edit;
      })
    },
    goDetails(id, name, detail, avatar) {
      this.$router.push('/anchor-detail?id=' + id + '&name=' + name + '&detail=' + detail + '&avatar=' + avatar)
    },
    // 关注主播
    onFollow(id) {
      this.loading = true;
      follow(Number(id)).then(({code}) => {
        if (code != 200) return;
        this.$message({message: "关注成功", type: "success",});
        this.tab = 1
        this.getFollows();
      }).finally(() => {
        this.loading = false;
      });
    },
    // 取消关注
    onUnfollow(id) {
      this.loading = true;
      unfollow(Number(id)).then(({code}) => {
        if (code != 200) return;
        this.$message({message: "已取消关注", type: "success",});
        this.tab = 1
        this.getFollows();
      }).finally(() => {
        this.loading = false;
      });
    },
    submitFb(){//提交反馈
      if(this.feedbackContent.length > 0){
        feedback(this.feedbackContent).then( (res) => {
          if (res.code == 200 ) {
            this.$message(
              {
                message: "提交成功",
                type: "success",
              }
            );
            this.feedbackContent = '';
          }
        })
      } else {
        this.$message( {
          message:"反馈内容不能为空",
          type:"error"
        })
      }
    },
    loadMore() {
      if (this.finished) return;
      this.getList(++this.page);
    },
    getFollows() {
      getFollows()
          .then((res) => {
            if (res.code == 200) {
              console.log(res)
              this.follows = res.data;
              console.log(this.follows)
            }
          });
    },
    getList(page) {
      let getList = this.tabs == 1 ? getSubscribeList : this.tabs == 2 ? getHistoryList : getFavsList
      getList({page}).then((res) => {
        if (res.code == 200) {
          let list = res.data.data.map(o => {
            o.live.start_at = moment(o.live.start_at, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")
            return o;
          });
          // this.tabs == 1
          //     ? res.data.data.filter((item) => {
          //       return !(
          //           moment(item.live.start_at).isBefore(moment()) && item.live.status == "0"
          //       );
          //     })
          //     : res.data.data;
          console.log(list)
          if (list.length < 10) this.finished = true;
          for (let i = 0; i < list.length; i++) {
            this.list.push(list[i]);
          }
        }
      });
    },
    getCaptcha() {
      this.captchaLoading = true;
      getCaptcha({mobile: this.mobile}).then((res) => {
        this.captchaLoading = false;
        if (res.code == 200) {
          this.captchaStatus = true;
        }
      });
    },
    submit2() {
      if(!(/^1[3-9]\d{9}$/.test(this.mobile) && this.mobile !== this.form.mobile)){
        this.$message({
          message:'电话号码格式不正确或与原来的电话号码相同',
          type:'error'
        })
      }else if (this.mobile) {
        profileEdit2({
          trainee_phone: this.mobile,
          old_trainee_phone: this.form.mobile,
          captcha: this.captcha,
          data_type: 1,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "修改成功，请重新登录",
              type: "success",
            });
            this.$store.dispatch("user/logout").then(() => {
              // this.$router.replace("/login");
              this.$router.push({
                path:"/login",
                query:{
                  redirect:"/profile"
                }
              });

            });
          }
        });
      } else {
        this.$message.error("请填写手机");
      }
    },
    submit() {
      console.log('showEdit',this.showEdit)
      if (this.formCheck()) {
        profileEdit({
          ...this.form,
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.clickToEdit();
            console.log('修改成功')
            this.$store.dispatch("user/getInfo");
            // this.$router.go(-1);
          }
        });
      }
    },
    imgUpload(e) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      fileUpload(formData).then((res) => {
        if (res.code == 200) {
          this.form.avatar = res.data.file;
        }
      });
    },
    formCheck() {
      if (!this.form.mobile) {
        this.$message({
          message: "请填写手机",
          type: "error",
        });
        return false;
      }
      if (!this.form.department) {
        this.$message({
          message: "请填写部门",
          type: "error",
        });
        return false;
      }
      if (!this.form.industry) {
        this.$message({
          message: "请选择行业",
          type: "error",
        });
        return false;
      }
      if (!this.form.email) {
        this.$message({
          message: "请填写邮箱",
          type: "error",
        });
        return false;
      }
      if (!this.form.company) {
        this.$message({
          message: "请填写企业名",
          type: "error",
        });
        return false;
      }
      if (!this.form.position) {
        this.$message({
          message: "请填写职位",
          type: "error",
        });
        return false;
      }
      // if (!this.form.name) {
      //   this.$message({
      //     message: "请填写姓名",
      //     type: "error",
      //   });
      //   return false;
      // }
      if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        this.$message({
          message: "手机号格式不正确",
          type: "error",
        });
        return false;
      }
      if (
          !/^([a-zA-Z\d])(\w|\-|\.)+@([a-zA-Z\d])(\w|\-)+(\.[a-zA-Z]{1,}){1,}$/.test(this.form.email)
      ) {
        this.$message({
          message: "邮箱格式不正确",
          type: "error",
        });
        return false;
      }
      if (this.form.position.length < 2) {
        this.$message({
          message: "职位内容过短",
          type: "error",
        });
        return false;
      }
      if (this.form.department.length < 2) {
        this.$message({
          message: "部门名称不能小于2位数",
          type: "error",
        });
        return false;
      }
      if (this.form.company.length < 2) {
        this.$message({
          message: "企业名称过短",
          type: "error",
        });
        return false;
      }
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-flow: row;
  padding-top: 10px;
  justify-content: center;
  width: auto;
  //background-color: rgba(255, 255, 255, 0.6);
}

.live {
  width: 800px;
  height: 640px;
  display: flex;
  flex-flow: column;
  margin-top: 20px;
  border: 1.5px solid rgb(158, 203, 169);
  border-radius: 25px;
  background: linear-gradient(0.00deg, rgba(249, 247, 214, 0.8) .190%, rgba(222, 251, 230, 0.8) 100%, rgba(222, 251, 230, 0.8) 0%);
}

.question {
  width: 800px;
  height: 85vh;
  //margin: 20px 10px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;

  .area {
    width: 800px;
    height: 550px;
    border: 2px solid rgb(41, 116, 66);
    border-radius: 10px;
    margin-top: 15px;

    textarea {
      width: 100.2%;
      height: 98%;
      font-size: 16px;
      font-weight: 500;
      border-top: 1px solid rgb(41, 116, 66);
      border-left: 1px solid rgb(41, 116, 66);
      border-right: 1px solid rgb(41, 116, 66);
      border-bottom: 2px solid rgb(41, 116, 66);
      border-radius: 10px;
      margin: -1px;
      padding: 20px;
    }
  }

  .bottom {
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-content: center;
    align-items: center;

    .main-btn {
      margin-top: 20px;
      height: 40px;
      background: rgb(12, 90, 31);
      border-radius: 15px;
      width: 100px;
      font-size: 20px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
    }
  }

}

.favorite {
  width: 800px;
  height: 640px;
  //margin: 20px 10px;
  margin-top: 20px;
  border: 1.5px solid rgb(158, 203, 169);
  border-radius: 25px;
  background: linear-gradient(0.00deg, rgba(249, 247, 214, 0.8) .190%, rgba(222, 251, 230, 0.8) 100%, rgba(222, 251, 230, 0.8) 0%);

  .top-list-li {
    margin: 15px 10px;
    float: left;
    width: 360px;
    height: 120px;
    background: rgb(255, 255, 255);
    border: 2px solid rgb(158, 203, 169);
    border-radius: 20px;
    color: rgb(158, 203, 169);

    .top-list {
      margin-top: -7px;
      width: 101%;
      height: 120px;
      margin-left: -1.5px;
      background: rgb(255, 255, 255);
      border: 2px solid rgb(158, 203, 169);
      border-radius: 20px;

      .avatar {
        margin-top: 10px;
        line-height: 120px;
        margin-left: 20px;

        .user-avatar {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          margin-top: -26px;
        }
      }

      .c-follow {
        margin-top: -110px;
        margin-left: 80%;
        font-size: 13px;
      }

      .follow {
        margin-top: -15px;
        margin-left: 90%;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .c-username {
        margin-top: -100px;
        margin-left: 35%;
        font-size: 18px;
        font-weight: 500;
      }

      .c-detail {
        margin-left: 35%;
        font-size: 10px;
        width: 60%;
        height: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.category {
  // width: 780vw;
  display: flex;
  flex-flow: row;
  margin: 20px 0px;

  .category-wrap {
    margin-left: 100px;
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
    text-align: center;
    white-space: nowrap;
    color: #0c5a1f;
    border: 1.5px solid #0c5a1f;
    border-radius: 10px;
    font-family: SourceHanSansCN-Medium;
    width: 160px;

    .category-card {
      background-color: #fff;
      border-bottom: 1.5px solid #0c5a1f;
      color: #0c5a1f;
      width: 100%;
      height: 95%;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin-left: 10px;
        width: 20px;
        height: 20px;
      }
    }
  }

  .actives {
    background-color: #0c5a1f;
    border: 1.5px solid #0c5a1f;
    width: 165px;
    height: 50px;
    border-radius: 10px;
    line-height: 50px;
    color: white;
    font-size: 20px;

    .category-card {
      background-color: #0c5a1f;
      border-bottom: 3px solid #fff;
      color: #fff;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin-left: 10px;
        width: 20px;
        height: 20px;
      }
    }
  }

}

.category-list {
  // width: 760vw;
  height: 530px;
  display: flex;
  flex-flow: column;
  margin: 0px 10px;

  .streaming-wrap {
    cursor: pointer;
    border-radius: 6px;
    display: flex;
    flex-flow: column;
    align-items: center;
    position: relative;
    width: 338px;
    height: auto;
    box-sizing: border-box;
    margin: 0px 20px;
    float: left;

    .streaming-img {
      width: 100%;
      height: 160px;
      border-radius: 10px;
      margin-right: 20px;
      border: 2px solid #a7caac;
      padding-bottom: 5px;
      background-color: #FFFFFF;

      img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        border-bottom: 2px solid #a7caac;
        object-fit: cover;
      }
    }

    .streaming-time {
      color: #066103;
      font-size: 13px;
      line-height: 16px;
      padding: 10px 0 10px;
      background: #dbecd9;
      width: 100%;
      border-radius: 10px;
      text-align: center;
      margin-left: -20px;
      margin-top: 10px;
      margin-bottom: 20px;

      img {
        margin-top: -3px;
        margin-left: 10px;
        margin-right: 10px;
        width: 15px;
        vertical-align: middle;
      }
    }
  }
}

.my-list {
  margin: 20px 18px 10px 10px;

  .my-tab {
    display: flex;
    flex-flow: column;

    .tab {
      width: 60px;
      height: 213px;
      color: #0c5a1f;
      border: 1.8px solid #0c5a1f;
      border-radius: 10px;
      justify-content: center;
      display: flex;
      flex-flow: column;
      padding: 15px;
      font-size: 26px;
      margin-bottom: 1px;
      background: #ffffff;
      img {
        width: 30px;
        height: 30px;
        margin-top: 10px;
      }
    }

    .show {
      width: 20px;
      height: 30px;
      position: absolute;
      margin-left: 58px;
      margin-top: 90px;
    }

    .show1 {
      width: 20px;
      height: 30px;
      position: absolute;
      margin-left: 58px;
      margin-top: 304px;
    }

    .show2 {
      width: 20px;
      height: 30px;
      position: absolute;
      margin-left: 58px;
      margin-top: 516px;
    }

    .active {
      color: #fff !important;
      background: #0c5a1f;
      border: 1.8px solid #0c5a1f;
      width: 60px;
      height: 213px;
      border-radius: 10px;
      justify-content: center;
      display: flex;
      flex-flow: column;
      padding: 15px;
      font-size: 26px;
      margin-bottom: 1px;

      img {
        width: 30px;
        height: 30px;
        margin-top: 10px;
      }
    }
  }
}

.main-container-bg {
  background: rgb(255, 255, 255);
  border: 1.8px solid rgb(158, 203, 169);
  border-radius: 10px;
  width: 340px;
  height: 100%;
  padding: 10px 0;
  margin: 20px 10px;
}

.main-container {
  width: 340px;
  height: 100%;
  //margin: 20px auto;
  margin-top: -12px;
  margin-left: -2px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  background: linear-gradient(0.00deg, rgba(249, 247, 214, 0.8) .190%, rgba(222, 251, 230, 0.8) 100%, rgba(222, 251, 230, 0.8) 0%);
  border: 1.8px solid rgb(158, 203, 169);
  border-radius: 10px;

  .bg {
    width: 100%;
    height: 100%;
    background-image: url('../../assets/zhibo/bg_line.png');
    background-size: 100%;
    padding: 15px;
  }

  .top-button {
    font-size: 14px;
    color: rgb(12, 90, 31);
    line-height: 24px;
    text-align: right;
  }

  .info-wrap-top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;

    .info-content {
      position: relative;
      cursor: pointer;
      .info-name {
        color: rgb(12, 90, 31);
        font-family: SourceHanSansCN-Medium;
        font-size: 24px;
        background: none;
        text-align: center;
      }
    }
  }

  .info-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
    border-bottom: 1px dashed rgb(158, 203, 169);

    .info-header {
      font-size: 16px;
      font-weight: bold;
      color: rgb(0, 0, 0);

      img {
        width: 17px;
        height: 16px;
        margin-bottom: 5px;
        margin-left: 5px;
        margin-right: 8px;
      }
    }

    .info-content {
      position: relative;
      font-size: 16px;
      color: rgb(0, 0, 0);
      cursor: pointer;
      .user-avatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        background: #dfdfdf;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .input-invisible {
        position: absolute;
        left: 0;
        z-index: 2;
        opacity: 0;
      }

      input {
        width: 220px;
        padding: 0 10px;
        border: none;
        height: 40px;
        border-radius: 10px;
        background: center;
        cursor: pointer;
      }
    }
  }

  .main-btn {
    height: 40px;
    background: rgb(12, 90, 31);
    border-radius: 15px;
    width: 130px;
    font-size: 24px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    margin: 0px;
  }
}

.input-area {

  .input-cell {
    overflow: hidden;
    position: relative;

    .input-header {
      font-size: 16px;
      color: #333333;
      line-height: 40px;
    }

    input {
      font-size: 14px;
      background-color: #f8f8f8;
      padding: 0 10px;
      width: 100%;
      border: 1.5px solid rgb(41, 116, 66);
      height: 40px;
      border-radius: 10px;
      cursor: pointer;
    }

    .captcha-btn {
      height: 40px;
      position: absolute;
      bottom: 0;
      right: 0;
      border-radius: 10px;
      width: 100px;
      background: rgb(41, 116, 66);
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    .btn-disabled {
      background: rgb(92, 139, 108);

      .block {
        height: 100%;
        color: #fff;
        line-height: 40px;
      }
    }
  }
}
</style>
